<div class="scanner-panel px-3 py-3 rounded-md flex flex-col gap-1">
  <label [ngClass]="labelClass">{{ currentLabel }}</label>
  <div class="flex items-center gap-2">
    <i class="pi pi-qrcode scanner-icon"></i>
    <input
      #scanInput
      class="w-36"
      pInputText
      [(ngModel)]="scannedValue"
      name="scannedValue"
      autocomplete="off"
      [maxlength]="maxLength"
      [attr.size]="maxLength"
      [disabled]="disabled || isSearching"
      (input)="onInput($event)"
      title="Scanner Input"
    />
  </div>
  <div *ngIf="errorMessage" class="text-red-500 text-sm font-semibold">
    {{ errorMessage }}
  </div>
</div>
